import { render, staticRenderFns } from "./ProjectDocumentList.vue?vue&type=template&id=66ffd075&scoped=true"
import script from "./ProjectDocumentList.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentList.vue?vue&type=script&lang=js"
import style0 from "./ProjectDocumentList.vue?vue&type=style&index=0&id=66ffd075&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ffd075",
  null
  
)

export default component.exports